/**
 * @fileoverview Vuex mutations for maker-checker state management.
 *
 * @module store/modules/makerchecker/mutations
 *
 * Handles synchronous state updates for:
 * - Pending and completed changes lists
 * - Filter states (main type, department)
 * - User authentication and permissions
 */

import { MutationTree } from "vuex/types";

import { MakerCheckerState } from "./types";

const mutations: MutationTree<MakerCheckerState> = {
  /**
   * Replaces the entire pending changes list.
   *
   * @param payload - Array of pending changes
   */
  SET_PENDING_CHANGES(state, payload) {
    state.pendingChanges = payload;
  },
  /**
   * Replaces the entire completed changes list.
   *
   * @param payload - Array of completed changes
   */
  SET_COMPLETED_CHANGES(state, payload) {
    state.completedChanges = payload;
  },
  /**
   * Appends new changes to the completed list (for pagination).
   *
   * @param payload - Array of additional completed changes
   */
  UPDATE_COMPLETED_CHANGES(state, payload: any) {
    state.completedChanges.push(...payload);
  },
  /**
   * Sets the main type filter (intent, entity, dialog, editor).
   *
   * @param payload - Type string or empty string for all
   */
  SET_MAIN_TYPE(state, payload: any) {
    state.mainType = payload;
  },
  /**
   * Sets the department filter for viewing changes.
   *
   * @param payload - Department string or empty for all
   */
  SET_DEPARTMENT_TYPE(state, payload: any) {
    state.currentDepartment = payload;
  },
  /**
   * Sets user authentication and permission metadata.
   *
   * @param appMetadata - User metadata including departments
   */
  SET_USER_AUTHENTICATION(state, appMetadata) {
    state.userAuthentication = appMetadata;
  },
};

export default mutations;
